import React, { FC, ReactNode, createContext, useState } from 'react';
import DefaultAvatar from '../assets/images/profile-avatars/avatar.svg';
import { useLazyGetMyProfileQuery } from '../services/api';
import { useAuth } from '../hooks/useAuth';

export const AvatarContext = createContext<{
  avatar: string;
  setAvatar: (avatar: string) => void;
}>({
  avatar: DefaultAvatar,
  setAvatar: () => {}
});

export const AvatarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, userId } = useAuth();
  const [getUserData] = useLazyGetMyProfileQuery();
  const [avatar, setAvatar] = useState<string>(DefaultAvatar);

  React.useEffect(() => {
    if (isAuthenticated && userId) {
      const fetch = async () => {
        try {
          const responseData = await getUserData({ id: userId }).unwrap();
          if (responseData.image) {
            setAvatar(responseData.image);
          }
        } catch (err) {
          console.log('err', err);
        }
      };
      fetch();
    }
  }, [isAuthenticated, userId, getUserData]);

  return (
    <AvatarContext.Provider
      value={{
        avatar,
        setAvatar
      }}
    >
      {children}
    </AvatarContext.Provider>
  );
};
